import React from 'react';
import { Button } from 'react-bootstrap';

const Notification = ({ 
    show = true, 
    title = 'Atualizações Disponíveis!', 
    message = 'Algum registro foi inserido ou alterado, deseja recarregar a tela para visualizar?', 
    onUpdateRequested = () => {}, 
    onClose = () => {}, 
    buttonTitle = 'Recarregar Tela' 
}) => {
    if (!show) {
        return <></>;
    }

    return (
        <div className='notification-div'>
            <div className='notification-title'>
                <h5>{title}</h5>
                <span onClick={onClose}>x</span>
            </div>
            <div className='notification-content'>
                {message}
                <Button
                    size="sm"
                    variant='secondary'
                    onClick={onUpdateRequested}
                >
                    {buttonTitle}
                </Button>
            </div>
        </div>
    );
}

export default Notification;